var availablePoints = 0;
var minimumRedeemPoints = 0;
var pointConversion = 0.033; //Default

$(document).ready(function() {
    var $rewardbox = $('.rewardbox'),$rewardboxTitle = $('.rewardbox__title');
    $rewardboxTitle.on('click', function() {
    });
    var loyaltyPointButton = $('.loyalty-point-button'),$rewardboxTitle = $('.rewardbox__title');
    $('.loyalty-point-button,.rewardbox__title__close').on('click', function() {
      	$rewardbox.toggleClass('hide-loyalty-block');
        $rewardbox.toggleClass('rewardbox--tray');
    });
  
    //Loyalty List
  	loadLoyaltyWidgetData();
  
    $("#claim_points, #claim_amount").keyup(function(){
      var points = amount = 0;
      var attrName = $(this).attr("name");
      var attrValue = $(this).val();
      if(attrName == "claim_points") {
        var conv = attrValue * pointConversion;
        points = attrValue;
        amount = conv;
        $("#claim_amount").val(Number(amount).toFixed(2));
      } else if(attrName == "claim_amount") {
        var conv = attrValue / pointConversion;
        points = conv;
        amount = attrValue;
        $("#claim_points").val(Number(points).toFixed(2));
      }
  	});
});

function showLoyalCouponCode(couponCode) {
  $(".loyal-cc-show").css("display", "inline-block");
  $(".loyal-cc-code").html(couponCode);
  
  $(".loyalty-cc-after").css("display", "none");
  $(".loyalty-cc-before").css("display", "block");
}

function copyCloseButton() {
  $(".loyalty-cc-after,.loyalty-cc-before,.loyal-cc-show").css("display", "none");
}

function copyCcToClipboard() {
  var copyText = $(".loyal-cc-code").html();
  var $body = document.getElementsByTagName('body')[0];
  var $tempInput = document.createElement('INPUT');
  $body.appendChild($tempInput);
  $tempInput.setAttribute('value', copyText)
  $tempInput.select();
  document.execCommand('copy');
  $body.removeChild($tempInput);
  $(".loyalty-cc-after").css("display", "block");
  $(".loyalty-cc-before").css("display", "none");
  $(".loyal-cc-copied").html("Copied");
}

function showHideLoyalCcDate(refId, type) {
  $(".loyal-info-desc").css("display", "none");
  if (type == "show") {
    $(".loyal-info-desc-"+refId).css("display", "block");
  }
}

var loyaltyData = {
	loyalty: [],
	//siteBaseUrl: siteBaseUrl,
};

function rewardBlockHide() {
  $(".rewards-block").toggleClass('rewards-block-hide');
  changeText = "HIDE";
  if ($(".rewards-block").hasClass("rewards-block-hide")) {
    changeText = "SHOW";
  }
  $("#reward_block_hide_txt").html(changeText);
}

function openLoyaltyTab(tabReference) {
  $(".loyal-content").removeClass("active").removeClass("show");
  $("#"+tabReference).addClass("active").addClass("show");
  
  $(".nav-tab-link").removeClass("active");
  $("."+tabReference+"_tab").addClass("active");
}

function toCommas(value) {
  	value = parseFloat(value).toFixed(2);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function loyaltyWidgetDataCallback(response) {
  if (response.status == 'success') {
	loyaltyData.loyalty = response;
    //success
    availablePoints = response.data.available_points;
    minimumRedeemPoints = response.data.minimum_redeem_points;
    pointConversion = response.data.point_conversion;
    $(".avail-points-val").html(toCommas(availablePoints));

    pendingPoints = response.data.pending_points;
    $(".pending-points-val").html(toCommas(pendingPoints));
  } else {
    //failure
  }
  $("#claim_amount").attr("placeholder", pointConversion);

    loyaltyData.loyalty = response;
    if (document.querySelector('#loyalty_block_template') !== null) {
        var source = document.querySelector("#loyalty_block_template").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(loyaltyData);
        var destination = document.querySelector(".active_records_block");
        destination.innerHTML = html;
    }
}

function createLoyaltyCoupon() {
  $("#claim_points_warn").html("");
  totalAvailPoints = parseFloat(availablePoints);

  claimPoints = $('#claim_points').val();
  //alert(checkDecimal(claimPoints));
  //return false;
  claimPointsParsed = parseFloat($('#claim_points').val());
  
  loyalErrorMsg = "";
  if (claimPoints == "") {
	loyalErrorMsg = "Please enter the claims point";
  }else if ( isNaN(claimPointsParsed) == true || checkDecimal == false || claimPointsParsed <= 0) {
    loyalErrorMsg = "Please enter valid claims point";
  }/* else if(claimPointsParsed < minimumRedeemPoints) {
    loyalErrorMsg = "Claim Points must be greater than or equal to "+minimumRedeemPoints;
  }*/ else if (claimPointsParsed > totalAvailPoints) {
    loyalErrorMsg = "Your requested point is not available";
  }
  
  if (loyalErrorMsg == "") {
    claimPointsParsed = claimPointsParsed.toFixed(2);
    //alert(claimPointsParsed);
    $("#claim_points").val(claimPointsParsed);
    //Validation success
    $("#loyal_create_coupon").attr("disabled",true);
    $(".loading-icon").css("display", "inline-block");
    if (loggedCustomerId != "") {
      var createCouponUrl = appBaseUrl + "api/loyalty/create-coupon?customerId="+loggedCustomerId+"&customerEmail="+loggedCustomerEmail+"&points="+claimPointsParsed;
      $.ajax({
        type: 'GET',
        url: createCouponUrl,
        dataType: "jsonp",
      });
    }
    
  } else {
    //Validation failure
    $("#claim_points_warn").html(loyalErrorMsg);
    return false;
  }
}

function createCouponCallback(response) {
  if (response.status == 'success') {
    //success
    newDiscountCode = response.data.discount_code;
    //alert('newDiscountCode '+newDiscountCode);
    loadLoyaltyWidgetData();
    showLoyalCouponCode(response.data.discount_code);
    $("#loyal_create_coupon").prop("disabled", false);
    $(".loading-icon").css("display", "none");
  } else {
    //failure
    $("#loyal_create_coupon").prop("disabled", false);
    $(".loading-icon").css("display", "none");
    $("#claim_points_warn").html(response.message);
  }
}

function checkDecimal(inputtxt) {
  	var decimal = /^(\+|-)?(\d*\.?\d*)$/;
	if(inputtxt.match(decimal)) {
		return true;
	} else {
		return false;
	}
}

function loadLoyaltyWidgetData() {
  if (loggedCustomerId != "") {
      var loyaltyListUrl = appBaseUrl + "api/loyalty/widget-data?customerId="+loggedCustomerId+"&customerEmail="+loggedCustomerEmail;
      $.ajax({
        type: 'GET',
        url: loyaltyListUrl,
        dataType: "jsonp",
      });
    }
}

